import { fetchContentApi } from '../../services/content-api'

export const apiFetchFAQ = async (
  currentPhoneId,
  preSaleFlag,
  language,
  customer
) => {
  const preSaleURL = preSaleFlag ? '&presales=1' : ''
  return fetchContentApi(
    `/faqs?language=${language}&phoneId=${currentPhoneId}` +
      `&customer=${customer}${preSaleURL}`
  )
}



// WEBPACK FOOTER //
// ./src/containers/FAQs/services.js